$("#subButton").click(function() {
	// prevent default
	event.preventDefault();
	$("#subBox").toggle("slow", function() {
		// Animation complete.
	});
});



// WEBPACK FOOTER //
// ./assets/js/modules/subprocessorBox.js